export const exclusionHatchStyle = {
  backgroundImage:
    'repeating-linear-gradient(-45deg, rgba(220,38,38,0.12), rgba(220,38,38,0.12) 4px, rgba(220,38,38,0.55) 4px, rgba(220,38,38,0.55) 6px)',
}

export const exclusionTitle = 'ohne Stellvertretung'
